import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const SettingsCard = ({ title, children, actions }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '8px',
      }}
    >
      {title && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            pb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600 }}>
            {title}
          </Typography>
          {actions && <Box>{actions}</Box>}
        </Box>
      )}
      {children}
    </Paper>
  );
};

export default SettingsCard;